module.exports = __webpack_public_path__ + "img/symbol_s01.7eb8096.svg";